import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { apiUrl, SkuRankingQueries, FILTER_CONFIGS_HQ } from 'src/app/model/constants';
import { isObjEmpty, objectToQueryString,objectToQueryStringHaveLstObject } from 'src/app/helpers/utils';

export class SkuRankingHelper {
  private static loadingSubject = new BehaviorSubject<boolean>(false);
  private static salesDateSubject = new BehaviorSubject<any>(null);
  private static salesDateWeekSubject = new BehaviorSubject<any>(null);
  private static dateInJobClearCache = new BehaviorSubject<string>('');
  private static loadingCount = 0;
  private static userGroupName = '';
  private static lstAllOptionsBottlerSaleData = new BehaviorSubject<any>(null);
  private static lstAllOptionsBottlerEnData = new BehaviorSubject<any>(null);
  private static lstAllOptionsCategoryData = new BehaviorSubject<any>(null);
  private static lstAllOptionsMarkerBrandData = new BehaviorSubject<any>(null);
  private static lstAllOptionsPackageData = new BehaviorSubject<any>(null);

  public static getSalesDate() {
    return this.salesDateSubject.asObservable();
  }

  public static setSalesDate(salesDate: string[]) {
    return this.salesDateSubject.next(salesDate);
  }

  public static getSalesDateWeek() {
    return this.salesDateWeekSubject.asObservable();
  }

  static getIntageskurankingsalesfilter(http: HttpClient, dateInJobClearCache: string, groupName: string): Promise<any> {
    if (this.dateInJobClearCache.value.length <= 0 && dateInJobClearCache.length > 0) {
      this.dateInJobClearCache.next(dateInJobClearCache);
    }
    const today = new Date().toISOString().split("T")[0];
    const bodyObj = {
      Code: SkuRankingQueries.salesDateFilter,
      CacheKey: `?code=${SkuRankingQueries.salesDateFilter}&date=${today}`,
      Selected: {}
    };

    const httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'text'
    }

    return new Promise<any>((resolve, reject) => {
      http.post<any>(apiUrl, bodyObj, httpOptions)
        .subscribe(
          response => {
            const data = JSON.parse(response);
            const data2 = { DATE_TYPE: ['Week', 'Month', 'Quarter', 'Half', 'Year'] };
            this.setSalesDate(data2?.DATE_TYPE);
            this.salesDateWeekSubject.next(data?.FiltersIntageWeek);
            this.lstAllOptionsBottlerSaleData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS1 || [],
              filtersWeek: data?.FiltersIntageWeek,
              data: data?.FiltersBottlerSale
            });
            resolve(data);
          },
        );
    });
  }

  static getIntageskurankingAllfilterInit(http: HttpClient, dateInJobClearCache: string, groupName: string): Promise<any> {
    if (this.dateInJobClearCache.value.length <= 0 && dateInJobClearCache.length > 0) {
      this.dateInJobClearCache.next(dateInJobClearCache);
    }
    const today = new Date().toISOString().split("T")[0];
    const bodyObj = {
      Code: SkuRankingQueries.allFilter,
      CacheKey: `?code=${SkuRankingQueries.allFilter}&date=${today}`,
      Selected: {}
    };

    const httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'text'
    }

    return new Promise<any>((resolve, reject) => {
      http.post<any>(apiUrl, bodyObj, httpOptions)
        .subscribe(
          response => {
            const data = JSON.parse(response);
             this.lstAllOptionsBottlerEnData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS5 || [],
              data: data?.FiltersBottlerEn
            });
            this.lstAllOptionsCategoryData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS2 || [],
              data: data?.FiltersIntageCategory
            });
            this.lstAllOptionsMarkerBrandData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS3 || [],
              data: data?.FiltersIntageMakerBrand
            });
            this.lstAllOptionsPackageData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS4 || [],
              data: data?.FiltersIntagePackage
            });
            resolve(data);
          },
        );
    });
  }

  static getLstAllOptionsBottlerSaleData() {
    return this.lstAllOptionsBottlerSaleData.asObservable();
  }
static getLstAllOptionsBottlerEnData() {
    return this.lstAllOptionsBottlerEnData.asObservable();
  }
  static getLstAllOptionsCategoryData() {
    return this.lstAllOptionsCategoryData.asObservable();
  }

  static getLstAllOptionsMarkerBrandData() {
    return this.lstAllOptionsMarkerBrandData.asObservable();
  }

  static getLstAllOptionsPackageData() {
    return this.lstAllOptionsPackageData.asObservable();
  }


  static isAllSelected = (arr1: any) => {
    return JSON.stringify(arr1) === JSON.stringify(['All']);
  }

  public static SkuRankingVsLyRankingSetQueryString(lstOptionSelected: object) {
    const analyticsQuery = {
      Selected: {},
      UnSelected: {}
    };
    let cacheKey = '';

    if (lstOptionSelected) {
      for (const key in lstOptionSelected) {
        if (lstOptionSelected.hasOwnProperty(key) && key != 'AggregateBy') {
          if (!this.isAllSelected(lstOptionSelected[key])) {
            analyticsQuery['Selected'][key] = lstOptionSelected[key];
          }
        }
      }
    }

    if (!isObjEmpty(analyticsQuery?.Selected)) {
      cacheKey += `&${objectToQueryString(analyticsQuery['Selected'])}`;
    }

    if (!isObjEmpty(analyticsQuery?.UnSelected)) {
      cacheKey += `&${objectToQueryString(analyticsQuery['UnSelected'])}`;
    }

    analyticsQuery['CacheKey'] = cacheKey;
    return analyticsQuery;
  }

  public static GetSkuRankingVsLyRankingData(http: HttpClient, analyticsQuery: object) {
    analyticsQuery['Selected']['PERIOD_TYPE'] = analyticsQuery['PERIOD_TYPE'];
    analyticsQuery['Selected']['TARGET_PERIOD'] = analyticsQuery['TARGET_PERIOD'];

    delete analyticsQuery['PERIOD_TYPE'];
    delete analyticsQuery['TARGET_PERIOD'];

    const bodyObj = {
      Code: SkuRankingQueries.skuRankingVsLyRanking,
      CacheKey: `?code=${SkuRankingQueries.skuRankingVsLyRanking}&filterOptionsGroup=${encodeURIComponent(this.userGroupName)}&LatestUpdate=${this.dateInJobClearCache.value}&${objectToQueryString(analyticsQuery['Selected'])}`,
      Selected: analyticsQuery['Selected']
    };

    const httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'text'
    }

    return new Promise<any>((resolve, reject) => {
      http.post<any>(apiUrl, bodyObj, httpOptions)
        .subscribe(
          response => {
            const data = JSON.parse(response);
            resolve(data);
          },
          error => {
            console.log(error);
          }
        );
    });
  }

  public static GetSkuRankingVsLyRankingTimelineData(http: HttpClient, analyticsQuery: object, timelineQuery?: object[]) {
    analyticsQuery['Selected']['PERIOD_TYPE'] = analyticsQuery['PERIOD_TYPE'];

    if (timelineQuery) {
      analyticsQuery['Selected']['LIST_PRODUCT'] = timelineQuery;
    }

    delete analyticsQuery['PERIOD_TYPE'];
    delete analyticsQuery['Selected']['TARGET_PERIOD'];

    const bodyObj = {
      Code: SkuRankingQueries.skuRankingVsLyRanking,
      CacheKey: `?code=${SkuRankingQueries.skuRankingVsLyRanking}&filterOptionsGroup=${encodeURIComponent(this.userGroupName)}&LatestUpdate=${this.dateInJobClearCache.value}&${objectToQueryStringHaveLstObject(analyticsQuery['Selected'])}`,
      Selected: analyticsQuery['Selected'],
      Page: 1,
      SortType: 'desc',
      SortBy: ''
    };

    const httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'text'
    }

    return new Promise<any>((resolve, reject) => {
      http.post<any>(apiUrl, bodyObj, httpOptions)
        .subscribe(
          response => {
            const data = JSON.parse(response);
            resolve(data);
          },
          error => {
            console.log(error);
          }
        );
    });
  }

  public static filterAndFormatSalesDateWeek(salesDateWeek: any[], selectedDateType: string): { value: string, name: string }[] {
    if (!salesDateWeek || !Array.isArray(salesDateWeek) || salesDateWeek.length === 0) {
      return [];
    }

    let filteredData: any[] = [];
    let formatKey: string = '';

    switch (selectedDateType) {
      case 'Week':
        formatKey = 'YMW';
        break;
      case 'Month':
        formatKey = 'YM';
        break;
      case 'Quarter':
        formatKey = 'YQ';
        break;
      case 'Half':
        formatKey = 'YH';
        break;
      case 'Year':
        formatKey = 'YR';
        break;
      default:
        formatKey = 'YMW'; // Default to Week
        break;
    }

    const uniqueValues = [...new Set(salesDateWeek.map(item => item[formatKey]))];

    filteredData = uniqueValues.map(value => ({
      value: value,
      name: value
    }));

    filteredData.sort((a, b) => {
      if (formatKey === 'YMW') {
        return a.value.localeCompare(b.value);
      } else if (formatKey === 'YM') {
        return a.value.localeCompare(b.value);
      } else if (formatKey === 'YQ') {
        return a.value.localeCompare(b.value);
      } else if (formatKey === 'YH') {
        return a.value.localeCompare(b.value);
      } else if (formatKey === 'YR') {
        return a.value.localeCompare(b.value);
      }
      return 0;
    });

    return filteredData;
  }
  public static getCacheKey(analyticsQuery: object) {
    let CacheKey = `filterOptionsGroup=${encodeURIComponent(this.userGroupName)}&LatestUpdate=${this.dateInJobClearCache.value}&${objectToQueryString(analyticsQuery['Selected'])}`;
    return CacheKey
  }
    public static getCacheKeyDetail(analyticsQuery: object) {
    let CacheKey = `filterOptionsGroup=${encodeURIComponent(this.userGroupName)}&LatestUpdate=${this.dateInJobClearCache.value}&${objectToQueryStringHaveLstObject(analyticsQuery['Selected'])}`;
    return CacheKey
  }
  public isAllSelected(selectedArr: string[]) {
    return selectedArr.length === 1 && selectedArr[0] === 'All';
  }

  static setLoading(loading: boolean) {
    return this.loadingSubject.next(loading);
  }

  static isLoading() {
    return this.loadingSubject.asObservable();
  }

  static startLoading() {
    this.loadingCount++;
    this.loadingSubject.next(true);
  }

  static stopLoading() {
    this.loadingCount--;
    if (this.loadingCount === 0) {
      this.loadingSubject.next(false);
    }
  }
  public static getIntageskurankingAllfilter(http: HttpClient, lstOption_Selected: any): Promise<any> {
    var analyticsQuery = {
      Selected: {}
    };
    if (lstOption_Selected) {
      for (const key in lstOption_Selected) {
        if (lstOption_Selected.hasOwnProperty(key) && key != 'AggregateBy') {
          if (!this.isAllSelected(lstOption_Selected[key])) {
            analyticsQuery['Selected'][key] = lstOption_Selected[key];
          }
        }
      }
    }
    const bodyObj = {
      Code: SkuRankingQueries.allFilter,
      nocache: true,
      Selected: analyticsQuery['Selected']
    };

    const httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'text'
    }
    //this.startLoading();
    return new Promise<any>((resolve, reject) => {
      http.post<any>(apiUrl, bodyObj, httpOptions)
        .subscribe(
          response => {
            const data = JSON.parse(response);
             this.lstAllOptionsBottlerEnData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS5 || [],
              data: data?.FiltersBottlerEn
            });
            this.lstAllOptionsBottlerSaleData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS1 || [],
              filtersWeek: data?.FiltersIntageWeek,
              data: data?.FiltersBottlerSale
            });
            this.lstAllOptionsCategoryData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS2 || [],
              data: data?.FiltersIntageCategory
            });
            this.lstAllOptionsMarkerBrandData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS3 || [],
              data: data?.FiltersIntageMakerBrand
            });
            this.lstAllOptionsPackageData.next({
              filters: FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS4 || [],
              data: data?.FiltersIntagePackage
            });
            //this.stopLoading();
            resolve(data);
          },
        );
    });
  }

}
